import React from "react"
import {EventResponse, ItemKeyEvents} from "../../../dtos/eventResponse"
import CircularIndeterminate from "../../feedback/CircularIndeterminate"
import * as Order from "../../../dtos/orderResponse"
import ItemEventAccordion from "./ItemEventAccordion"
import OrderEventAccordion from "./OrderEventAccordion"
import {Card, Container, Grid, InputBase} from "@mui/material"
import {makeStyles} from "tss-react/mui"

interface EventHistoryProps {
	events: EventResponse | null
	order: Order.Order
	locale: string
}

let loadingEvents: boolean = true

const useStyles = makeStyles()({
	text: {
		marginLeft: "0px",
		marginRight: "0px",
		alignmentBaseline: "central",
		width: "100%",
	},
	loading: {
		size: "40",
		left: "-20",
		marginLeft: "50%",
		alignContent: "center",
		paddingTop: "50px",
	},
	card: {
		padding: "15px",
		margin: "15px",
	},
})

export default function EventHistoryV2(props: EventHistoryProps) {
	const {classes} = useStyles()
	loadingEvents = typeof props.events === "undefined"
	const [expanded, setExpanded] = React.useState<string>("")
	const orderDate = new Date(props.order ? props.order.orderData.orderCreationDate : "").toString()
	const updateExpandedPanel = (expanded: string) => {
		setExpanded(expanded)
	}

	const getItemEvents = (itemId: string): ItemKeyEvents | undefined => {
		if (props.events) {
			const itemKeyEvents = props.events.itemEvents.filter(
				(lineItem) => lineItem.itemdId === itemId
			)
			if (itemKeyEvents && itemKeyEvents.length > 0) {
				return itemKeyEvents[0]
			}
		}
	}

	return loadingEvents ? (
		<div className={classes.loading}>
			<CircularIndeterminate />
		</div>
	) : props.events === null ? (
		<div>
			<Container maxWidth="xs">
				<InputBase
					className={classes.text}
					defaultValue="Event history is not available for this order"
					inputProps={{"aria-label": "naked"}}
				/>
			</Container>
		</div>
	) : (
		<div>
			{props.events && (
				<Card raised={true} className={classes.card}>
					<Grid
						container
						direction="column"
						spacing={2}
						alignItems="flex-start"
						justifyContent="center"
						style={{
							padding: "16px",
							width: "100%",
						}}
					>
						{props.order.orderData.lineItems.map((item) => {
							return (
								<ItemEventAccordion
									itemKeyEvents={getItemEvents(item.id)}
									lineItem={item}
									isOrderLegacy={props.order.isLegacy}
									expandedPanel={expanded}
									updateExpandedPanel={updateExpandedPanel}
									orderCreationDate={orderDate}
									locale={props.locale}
								/>
							)
						})}
						<OrderEventAccordion
							orderNumber={props.order.orderNumber}
							orderEvents={props.events.orderEvents}
							expandedPanel={expanded}
							updateExpandedPanel={updateExpandedPanel}
						/>
					</Grid>
				</Card>
			)}
		</div>
	)
}
